module.exports = __webpack_public_path__ + "abcfa39ae37d0f7c242a404867522c50.png";